import { Text, createStyles, Flex, Checkbox } from "@mantine/core";

import { useParams } from "react-router-dom";
import { decrypt } from "../../utils";

const useStyles = createStyles((theme) => ({
  border: {
    borderLeft: "1px solid var(--app-border)",
  },
  bg1: {
    "& td": {
      background: "var(--app-surface)",
    },
    cursor: "pointer",
  },
  bg2: {
    "& td": {
      background: "var(--app-surface-2)",
    },
    cursor: "pointer",
  },
}));

const ClientTableRow = ({
  row,
  index,
  setSelectedClientRows,
  selectedClientRows,
  data,
}) => {
  const { classes } = useStyles();
  const bg = index % 2 === 0;
  const { mode } = useParams();

  const isSelected = selectedClientRows?.some(
    (item) => item.clientId === row?.id && item.isAssign === true
  );

  const handleCheckboxChange = (event) => {
    const checked = event.currentTarget.checked;
    setSelectedClientRows((prev) => {
      const existingIndex = prev.findIndex(item => item.clientId === row?.id);
    
      if (existingIndex !== -1) {
        const updated = [...prev];
        updated[existingIndex] = { ...updated[existingIndex], isAssign: checked };
        return updated;
      } else {
        return [...prev, { clientId: row?.id, isAssign: checked }];
      }
    });
  };

  return (
    <tr
      style={{ cursor: "pointer", fontFamily: "Inter" }}
      className={bg ? classes.bg2 : classes.bg1}
      key={row?.id}
      bg={
        selectedClientRows?.includes(row?.id) ? "rgba(0, 0, 0, 0.1)" : undefined
      }
    >
      <td>
        <Flex justify="start" align="center" gap="md">
          <Checkbox
            size="md"
            variant="outline"
            type="checkbox"
            color="gray"
            aria-label="Select row"
            checked={isSelected}
            onChange={handleCheckboxChange}
            disabled={mode === "view"}
          />
          <Text>{decrypt(row?.name) || "-"}</Text>
        </Flex>
      </td>
      <td>{row?.facilityId?.map((f) => f?.name)?.join(", ") || "-"}</td>
      <td>{decrypt(row?.form1).zipCode || "-"}</td>
      <td>{decrypt(row?.form1).previousAddress || "-"}</td>
      <td>{decrypt(row?.form1).gender || "-"}</td>
      <td>{decrypt(row?.form1).phone || "-"}</td>
    </tr>
  );
};

export default ClientTableRow;
